(function($) {

	$(".c-scroll-arrow-top").click(function() {

		$(window).scrollTo("#page-top", 500,  {offset: -110});

	});


	$(window).scroll(function() {

		if($(window).scrollTop() >= 1000) $(".c-scroll-arrow-top").addClass("visible");
		if($(window).scrollTop() <= 1000) $(".c-scroll-arrow-top").removeClass("visible");

	});

})(jQuery);

